/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { iamLogin } from './main';
import { iamLocalization } from './localization';
import { iam } from './iam';

interface Invite {
  tenant_id: string,
  tenant_name: string
}

export class Invites {
  private invites: Invite[] = [];

  // Calls GET /invite API for current user's tenant invites
  private loadInvites(): Promise<Invite[]> {
    return new Promise<Invite[]>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            try {
              if (iam.settings.debug) console.log(xhr.responseText);
              resolve(JSON.parse(xhr.responseText));
            } catch (error) {
              reject(error);
            }
          } else if (xhr.status) {
            if (xhr.responseText) {
              console.error(xhr.responseText);
            }
            try {
              reject(xhr.status);
            } catch (error) {
              reject(error);
            }
          } else {
            reject(new Error(iamLocalization.localize('errorSendingRequest')));
          }
        }
      };
      xhr.open('GET', iam.settings.uamBackendURL + '/user/invite', true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + iam.Token.getItem('accessToken'));
      xhr.send();
    }).then(response => {
      console.log(JSON.stringify(response));
      return response;
    });
  }
  
  // Toggle modal to show or hide
  private toggleModal() {
    document.getElementById('outerModal').style.display = document.getElementById('outerModal').style.display === 'none' ? 'block' : 'none';
  }
  
  // Creates invites in table on modal
  private createInviteDiv(invite: Invite) {
    // Create single row for tenant invite
    const inviteDiv = document.createElement('div');
    inviteDiv.className = 'invite-div';
    inviteDiv.id = 'Tr' + invite.tenant_id;
    console.log('inviteTr.id ' + inviteDiv.id);
    // Display name of Tenant
    const inviteTextNode = document.createElement('span');
    inviteTextNode.id = 'Td' + invite.tenant_id;
    inviteTextNode.className = 'invite-tenant-name';
    inviteTextNode.textContent = invite.tenant_name;
    inviteTextNode.setAttribute('title', invite.tenant_name);
    inviteDiv.appendChild(inviteTextNode);
    // Accept button
    const inviteAccept = document.createElement('button');
    inviteAccept.className = 'invite-A-buttons';
    inviteAccept.id = 'inviteAccept' + invite.tenant_id;
    inviteAccept.onclick = () => {
      this.sendInviteAnswer('accept', invite.tenant_id, invite.tenant_name);
    };
    // inviteAccept.addEventListener('click', this.sendInviteAnswer('accept',app.tenant_id));
    inviteDiv.appendChild(inviteAccept);
    // Decline button
    const inviteDecline = document.createElement('button');
    inviteDecline.className = 'invite-D-buttons';
    inviteDecline.id = 'inviteDecline' + invite.tenant_id;
    inviteDecline.onclick = () => {
      this.sendInviteAnswer('decline', invite.tenant_id);
    };
    inviteDiv.appendChild(inviteDecline);
    document.getElementById('invite-table').appendChild(inviteDiv);

    iamLogin.registerLocalizationCallback(() => {
      // get button collections, convert to arrays, and translate
      let buttons = document.getElementsByClassName('invite-A-buttons');
      for (let i = 0; i < buttons.length; i++) {
        iamLogin.localizeElement(buttons[i], 'inviteModalAcceptButton');
      }
      buttons = document.getElementsByClassName('invite-D-buttons');
      for (let i = 0; i < buttons.length; i++) {
        iamLogin.localizeElement(buttons[i], 'inviteModalDeclineButton');
      }
    });
  }
  
  // Calls invites and displays the modal on teh screen
  public initializeInvites() {
    return this.loadInvites()
      .then(response => {
        // if there are invites for user
        if (response && response.length > 0) {
          this.invites = response;
          console.log(JSON.stringify(response));
          // Create table for invites to be generated in
          const outerTableDiv = document.createElement('div');
          outerTableDiv.id = 'invite-table';
          outerTableDiv.className = 'invite-table1';
          document.getElementById('invite-content').appendChild(outerTableDiv);
          response.forEach(element => {
            if (iam.settings.debug) console.log(element);
            this.createInviteDiv(element);
          });
          document.getElementById('invitations').style.display = 'block';
          if (this.invites.length > 1) {
            document.getElementById('invite-accept-all').style.display = 'block';
            document.getElementById('invite-decline-all').style.display = 'block';
          } else {
            document.getElementById('invite-accept-all').style.display = 'none';
            document.getElementById('invite-decline-all').style.display = 'none';
          }
          this.toggleModal();
        }
      }).catch(err => {
        console.log('unable to initialize invites: ' + JSON.stringify(err));
      });
  }
  
  // User input to Accept/Decline hides invite after decision. If no invites left close Modal and hide dashboard button
  public removeInviteFromTable(tenantId: string) {
    // Remove invite row from table
    document.getElementById('Tr' + tenantId).style.display = 'none';
    document.getElementById('Td' + tenantId).style.display = 'none';
    document.getElementById('inviteAccept' + tenantId).style.display = 'none';
    document.getElementById('inviteDecline' + tenantId).style.display = 'none';
    this.invites = this.invites.filter(invite => {
      return invite.tenant_id !== tenantId;
    });
    if (this.invites.length > 1) {
      document.getElementById('invite-accept-all').style.display = 'block';
      document.getElementById('invite-decline-all').style.display = 'block';
    } else {
      document.getElementById('invite-accept-all').style.display = 'none';
      document.getElementById('invite-decline-all').style.display = 'none';
    }
    if (this.invites.length <= 0) {
      document.getElementById('invitations').style.display = 'none';
      this.toggleModal();
    }
  }

  private inviteAll() {
    this.invites.forEach(invite => {
      this.sendInviteAnswer('accept', invite.tenant_id, invite.tenant_name);
    });
  }

  private declineAll() {
    this.invites.forEach(invite => {
      this.sendInviteAnswer('decline', invite.tenant_id, invite.tenant_name);
    });
  }
  
  // Send user request
  private sendInviteAnswer(answer: 'accept' | 'decline', tenantId: string, tenantName?: string) {
    console.log('inside sendInviteAnswer with values answer: ' + answer + ' and tenantId: ' + tenantId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 204) {
            try {
              resolve(undefined);
            } catch (error) {
              reject(error);
            }
          } else if (xhr.status) {
            try {
              reject(JSON.parse(xhr.responseText).error);
            } catch (error) {
              reject(error);
            }
          } else {
            reject(new Error(iamLocalization.localize('errorSendingRequest')));
          }
        }
      };
      if (answer === 'accept') {
        // Remove invite row from table. If no invites left then remove button from dashboard
        this.removeInviteFromTable(tenantId);
        this.pushNewTenant(tenantId, tenantName);
        xhr.open('POST', iam.settings.uamBackendURL + '/user/invite', true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + iam.Token.getItem('accessToken'));
        xhr.send(tenantId);
      } else if (answer === 'decline') {
        // Remove invite row from table
        this.removeInviteFromTable(tenantId);
        xhr.open('DELETE', iam.settings.uamBackendURL + '/user/invite', true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + iam.Token.getItem('accessToken'));
        xhr.send(tenantId);
      }
    });
  }

  private pushNewTenant(tenantId: string, companyName: string) {
    const tenants = JSON.parse(window.localStorage.getItem('tenants')) || [];
    tenants.push({
      tenantId,
      companyName
    });
    window.localStorage.setItem('tenants', JSON.stringify(tenants));
    document.querySelector('iam-tenant-list').setAttribute('tenants', JSON.stringify(tenants));
  }
}
